import { SortDirection } from "@/models"
import { css } from "vite-css-in-js"
import type { ThHTMLAttributes } from "vue"
import { defineComponent, inferProps, renderSlot, type ReactiveComponent } from "vue-utils"

interface Props {
	isSelected: boolean
	direction: SortDirection
	setDirection(direction: SortDirection): void
}

const headingStyles = css`
	&:hover {
		cursor: pointer;
		background-color: rgb(203, 225, 255);
	}
`

const SortDirectionHeading: ReactiveComponent<Props, ThHTMLAttributes> = (props, { attrs, slots }) => {
	function onSortClick() {
		if (props.isSelected && props.direction === SortDirection.Descending) {
			props.setDirection(SortDirection.Ascending)
		} else {
			props.setDirection(SortDirection.Descending)
		}
	}

	function getAriaSortValue(): ThHTMLAttributes["aria-sort"] {
		if (!props.isSelected) return "none"
		return props.direction === SortDirection.Ascending ? "descending" : "ascending"
	}

	return () => (
		<th class={headingStyles} onClick={onSortClick} aria-sort={getAriaSortValue()} {...attrs}>
			{renderSlot(slots)}
		</th>
	)
}

export default defineComponent(SortDirectionHeading, inferProps<Props>())
